import { ChangeEvent, ClickEvent, CrudDecorator, DataSourceMode, Layout, Switch, TableRow, TableSelectionEvent } from "@mcleod/components";
import { AutogenLayoutTopMatchProfileList } from "./autogen/AutogenLayoutTopMatchProfileList";
import { Api, ModelRow } from "@mcleod/core";
import { TopMatchProfile } from "./TopMatchProfile";

export class TopMatchProfileList extends AutogenLayoutTopMatchProfileList {

    onLoad(): void | Promise<void> {
        this.tableTopMatchProfiles.addSelectionListener((event: TableSelectionEvent) => {
            this.buttonCopyProfile.enabled = this.tableTopMatchProfiles.selectedRow != null;
        })
    }

    switchIsActiveOnChange(event: ChangeEvent) {
        if (event.userInitiatedChange) {
            const switchIsActive = event.target as Switch;
            const tableRow = TableRow.getContainingTableRow(switchIsActive);
            const modelRow = tableRow.data;
            modelRow.post().then(() => tableRow.displayComponentValues());
        }
    }

    async buttonCopyProfileOnClick(event: ClickEvent) {
        const selectedRow = this.tableTopMatchProfiles.selectedRow;
        const modelRow = selectedRow.data;
        const result = await Api.post('lme/powerbroker/topmatch/clone-profile', {"profile_id": modelRow.get('id')});
        const layout = Layout.getLayout(this.tableTopMatchProfiles.addLayout);
        this.tableTopMatchProfiles['crudPanel'] = new CrudDecorator({
            pseudoNavigateUrl: "/" + this.tableTopMatchProfiles.addLayout + "?mode=add",
            layout: layout,
            mode: DataSourceMode.ADD,
            headerProps: {
                showClose: true,
                showSaveAndClose: true,
                onExecute: (addedRow: ModelRow) => this.tableTopMatchProfiles.dataSource.addRow(addedRow, 0)
            },
            doAfterSlideIn: (decorator) => {
                const topMatchProfile = decorator.layout as TopMatchProfile;
                topMatchProfile.applyCloneValues(result.data?.[0]);
            }
        });
        this.tableTopMatchProfiles['crudPanel'].slideIn({ speed: 200 });
    }
}